"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TablesController", {
    enumerable: true,
    get: function() {
        return TablesController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _tablesservice = require("~/services/tables.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _PagedResponse = require("~/helpers/PagedResponse");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let TablesController = class TablesController {
    async tableList(context, baseId, sourceId, includeM2M, req) {
        var _req_user;
        return new _PagedResponse.PagedResponseImpl(await this.tablesService.getAccessibleTables(context, {
            baseId,
            sourceId,
            includeM2M: includeM2M === 'true',
            roles: (0, _nocodbsdk.extractRolesObj)(req.user.base_roles),
            user: req.user,
            isPublicBase: ((_req_user = req.user) == null ? void 0 : _req_user.isPublicBase) === true
        }));
    }
    async tableCreate(context, baseId, sourceId, body, req) {
        const result = await this.tablesService.tableCreate(context, {
            baseId: baseId,
            sourceId: sourceId,
            table: body,
            user: req.user,
            req
        });
        return result;
    }
    async tableGet(context, tableId, req) {
        const table = await this.tablesService.getTableWithAccessibleViews(context, {
            tableId: req.params.tableId,
            user: req.user
        });
        return table;
    }
    async tableUpdate(context, tableId, body, req) {
        await this.tablesService.tableUpdate(context, {
            tableId: tableId,
            table: body,
            baseId: req.ncBaseId,
            user: req.ncBaseId,
            req
        });
        return {
            msg: 'The table has been updated successfully'
        };
    }
    async tableDelete(context, tableId, req) {
        const result = await this.tablesService.tableDelete(context, {
            tableId: req.params.tableId,
            user: req.user,
            req
        });
        return result;
    }
    async tableReorder(context, tableId, body, req) {
        return this.tablesService.reorderTable(context, {
            tableId,
            order: body.order,
            req
        });
    }
    constructor(tablesService){
        this.tablesService = tablesService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/projects/:baseId/tables',
        '/api/v1/db/meta/projects/:baseId/:sourceId/tables',
        '/api/v2/meta/bases/:baseId/tables',
        '/api/v2/meta/bases/:baseId/:sourceId/tables'
    ]),
    (0, _extractidsmiddleware.Acl)('tableList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Param)('sourceId')),
    _ts_param(3, (0, _common.Query)('includeM2M')),
    _ts_param(4, (0, _common.Request)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String,
        String,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], TablesController.prototype, "tableList", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/projects/:baseId/tables',
        '/api/v1/db/meta/projects/:baseId/:sourceId/tables',
        '/api/v2/meta/bases/:baseId/tables',
        '/api/v2/meta/bases/:baseId/:sourceId/tables'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('tableCreate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Param)('sourceId')),
    _ts_param(3, (0, _common.Body)()),
    _ts_param(4, (0, _common.Request)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String,
        typeof _nocodbsdk.TableReqType === "undefined" ? Object : _nocodbsdk.TableReqType,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], TablesController.prototype, "tableCreate", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/tables/:tableId',
        '/api/v2/meta/tables/:tableId'
    ]),
    (0, _extractidsmiddleware.Acl)('tableGet'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_param(2, (0, _common.Request)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], TablesController.prototype, "tableGet", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/tables/:tableId',
        '/api/v2/meta/tables/:tableId'
    ]),
    (0, _extractidsmiddleware.Acl)('tableUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Request)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.TableReqType === "undefined" ? Object : _nocodbsdk.TableReqType,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], TablesController.prototype, "tableUpdate", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/meta/tables/:tableId',
        '/api/v2/meta/tables/:tableId'
    ]),
    (0, _extractidsmiddleware.Acl)('tableDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_param(2, (0, _common.Request)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        void 0
    ]),
    _ts_metadata("design:returntype", Promise)
], TablesController.prototype, "tableDelete", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/tables/:tableId/reorder',
        '/api/v2/meta/tables/:tableId/reorder'
    ]),
    (0, _extractidsmiddleware.Acl)('tableReorder'),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        Object,
        typeof _nocodbsdk.NcRequest === "undefined" ? Object : _nocodbsdk.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], TablesController.prototype, "tableReorder", null);
TablesController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _tablesservice.TablesService === "undefined" ? Object : _tablesservice.TablesService
    ])
], TablesController);
